var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 196,
    viewBox: "0 0 204 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18234_94779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.445 71.12C130.62 45.485 122.88 20.195 104.61 1.25L6.94501 30.26C45.1125 69.845 37.3425 137.112 71.22 177.342L168.885 148.333C160.125 137.93 154.147 125.713 149.438 112.64",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35 155.982C89.9301 155.982 96.075 149.838 96.075 142.257C96.075 134.677 89.9301 128.532 82.35 128.532C74.7699 128.532 68.625 134.677 68.625 142.257C68.625 149.838 74.7699 155.982 82.35 155.982Z",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.915 64.295L184.943 52.1225C187.32 49.16 186.953 44.8475 184.095 42.3425C180.998 39.62 176.243 40.1 173.745 43.385L115.77 116.472L114.338 127.047L124.913 124.985L168.03 72.635",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1875 101.892C82.35 108.185 76.23 114.087 71.88 115.512C65.4525 117.612 58.2825 114.702 55.4775 107.915C52.6725 101.135 55.4625 93.5374 61.71 90.9499C64.2975 89.8774 67.0725 89.8324 69.63 90.6274",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.27 100.752C64.5675 100.76 70.515 104.75 70.515 104.75C74.1375 94.3625 83.6625 83.975 83.6625 83.975",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.795 53.8701C61.9575 60.1626 55.8375 66.0651 51.4875 67.4901C45.06 69.5901 37.89 66.6801 35.085 59.8926C32.28 53.1051 35.07 45.5151 41.3175 42.9276C43.905 41.8551 46.68 41.8101 49.2375 42.6051",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8775 52.73C44.175 52.7375 50.1225 56.7275 50.1225 56.7275C53.745 46.34 63.27 35.9525 63.27 35.9525",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7525 43.1975L109.56 30.8075",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7125 52.535L94.5375 45.515",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6525 90.92L131.468 78.53",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.62 100.257L116.445 93.245",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.865 130.812L106.927 128.532",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.825 140.157L127.65 133.137",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0325 115.813C16.2972 115.813 20.565 111.545 20.565 106.28C20.565 101.015 16.2972 96.7476 11.0325 96.7476C5.76785 96.7476 1.5 101.015 1.5 106.28C1.5 111.545 5.76785 115.813 11.0325 115.813Z",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.428 38.8475C154.868 38.8475 158.467 35.2478 158.467 30.8075C158.467 26.3671 154.868 22.7675 150.428 22.7675C145.987 22.7675 142.388 26.3671 142.388 30.8075C142.388 35.2478 145.987 38.8475 150.428 38.8475Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.095 100.595C197.029 100.595 202.65 94.9739 202.65 88.04C202.65 81.106 197.029 75.485 190.095 75.485C183.161 75.485 177.54 81.106 177.54 88.04C177.54 94.9739 183.161 100.595 190.095 100.595Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.445 185.488C141.943 185.488 145.59 181.841 145.59 177.343C145.59 172.844 141.943 169.198 137.445 169.198C132.947 169.198 129.3 172.844 129.3 177.343C129.3 181.841 132.947 185.488 137.445 185.488Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.885 112.64V136.648",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.893 124.64H168.885",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5025 126.267V140.007",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3725 133.137H23.6325",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18234_94779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.65,
    height: 194.798,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.96064c6de6ffd0e97d03a334dcb19518.svg";
export { ForwardRef as ReactComponent };